import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

const getAllUsers = async () => {
  const response = await api.get("/users");
  return response.data;
};

export const useUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => getAllUsers(),
    gcTime: 1000 * 60 * 10, // Cache for 10 minutes
    refetchOnWindowFocus: false,
    retry: 0,
  });
};
